import React from "react"
import { StyledGetStartedIntro } from "@tmu/global/page-addons/how-it-works.styles"

const GetStartedIntro = ({ children }) => {
  return <StyledGetStartedIntro>{children}</StyledGetStartedIntro>
}

export default GetStartedIntro
